import React, { useContext } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

function CatProductListing({ title, adverts = [] }) {
  const { formatNumber, categories, searchAds } = useContext(AppContext);
  const [category, setCategory] = React.useState("");
  let navigate = useNavigate();

  return (
    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div className="module product-simple">
        <h3 className="modtitle"><span>{title}</span></h3>

        <div
          className="row"
          style={{
            display: adverts && adverts.length !== 0 ? "none" : "block",
          }}
        >
          {/* skeleton loaders... */}
        </div>

        <div className="modcontent">
          <div className="yt-content-slider extraslider-inner">
            <div className="item">
              {adverts.length > 0 &&
                adverts
                  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                  .slice(0, 5)
                  .map((item, index) => (
                    <div
                      className="product-item-container product-layout item-inner"
                      key={index}
                    >
                      <div className="item-image">
                        <div className="product-image-container second_img">
                          <Link to={`/advert/${item.id}`} className="small-img-hold">
                            <img
                              src={item.images?.[0] || "/placeholder.jpg"}
                              className="img-1 img-responsive"
                              alt="image1"
                            />
                            <img
                              src={item.images?.[1] || item.images?.[0] || "/placeholder.jpg"}
                              className="img-2 img-responsive"
                              alt="image2"
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="item-info">
                        <div className="item-title" style={{ marginTop: 0 }}>
                          <Link to={`/advert/${item.id}`} style={{ fontSize: 15 }}>
                            {item.title}
                          </Link>
                        </div>
                      </div>

                      <div className="price">
                        <span className="price">₦{formatNumber(item.price)}</span>
                      </div>
                    </div>
                  ))}
            </div>
          </div>

          <div className="search-button">
            <button
              type="button"
              className="viewmore"
              onClick={() => {
                const matchedCategory = categories?.find(
                  (cat) => cat.name.toLowerCase() === title.toLowerCase()
                );
                if (matchedCategory) {
                  const categoryId = matchedCategory.id;
                  setCategory(categoryId);
                  searchAds(categoryId, "", "", "", "");
                  navigate("../search", { replace: true });
                } else {
                  console.warn("Category not found for title:", title);
                }
              }}
            >
              View ALL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


export default CatProductListing;
